// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2PU7W","gfeWrapper":"CalendarEvent_gfeWrapper__QOYGn"};